import React from 'react';

const VehicleCard = ({ vehicle, onCardClick }) => {
  return (
    <div
      className="vehicle-card"
      onClick={() => onCardClick(vehicle)}
    >
      <div className="vehicle-image">
        <img
          src={vehicle.images[0]}
          alt={vehicle.title}
          onError={(e) => (e.target.src = "/img/datlogoA.png")}
        />
      </div>
      <div className="vehicle-info">
        <h3>{vehicle.title}</h3>
      </div>
    </div>
  );
};

export default VehicleCard;